module.exports = __webpack_public_path__ + "img/picture.ab21c89d.png";